module.exports = __webpack_public_path__ + "img/qr_tutor_300.ab6dca02.png";